import { render, staticRenderFns } from "./RankingCell.vue?vue&type=template&id=6edf2908&scoped=true&"
import script from "./RankingCell.vue?vue&type=script&lang=js&"
export * from "./RankingCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edf2908",
  null
  
)

export default component.exports